// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1GNKg","col":"CardReaderDesc_col__2pZDH","label":"CardReaderDesc_label__Vubq1"};